import * as React from 'react'
import { Descriptions } from 'antd'
import { FormattedMessage } from 'react-intl'
import { Customer } from '../../types'
import { useIsSmartHubAdmin, useSmartHubType } from '../../queries'

export const ShowPayer = ({ payer }: { payer: Customer }) => {
  const smartHubAdmin = useIsSmartHubAdmin()
  const smartHubType = useSmartHubType()
  return (
    <Descriptions column={1} layout="horizontal">
      <Descriptions.Item span={1} label={<FormattedMessage id="payerName" />}>
        {payer.name}
      </Descriptions.Item>
      <>
        {smartHubAdmin || smartHubType.data?.smartHubType !== '' ? (
          <Descriptions.Item
            span={1}
            label={<FormattedMessage id="crNumber" />}
          >
            {payer.taxNumber ?? <FormattedMessage id="noCRNFound" />}
          </Descriptions.Item>
        ) : (
          <Descriptions.Item
            span={1}
            label={<FormattedMessage id="phonenumber" />}
          >
            {payer.phoneNumber}
          </Descriptions.Item>
        )}
      </>
      <Descriptions.Item span={1} label={<FormattedMessage id="address" />}>
        {payer.email ?? <FormattedMessage id="noAddressFound" />}
      </Descriptions.Item>
    </Descriptions>
  )
}
